module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bold-webfont.59d7713a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bold-webfont.svg
// module id = 384
// module chunks = 3